// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UploadImage_wrapper__mTPTv"};